/**
 * Catch-all within the authenticated shell. Links back to the app root, which
 * redirects to /dashboard — so the link reuses the `nav.dashboard` label
 * rather than inventing a new "home"/"back" copy key out of scope for this
 * unit's locale changes.
 */
import { Box, Button, Stack, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useCopy } from '@/hooks/useCopy';

export function NotFound() {
  const { t } = useCopy();

  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        px: 2,
      }}
    >
      <Stack spacing={2} sx={{ alignItems: 'center' }}>
        <Typography variant="h2" component="h1">
          {t('errors.notFoundTitle', 'Not found')}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 480 }}>
          {t('errors.notFoundBody', "We couldn't find what you were looking for.")}
        </Typography>
        <Button variant="outlined" component={NavLink} to="/">
          {t('nav.dashboard', 'Dashboard')}
        </Button>
      </Stack>
    </Box>
  );
}
